export enum StatusPagamentoEnum {
  paid = "paid",
  canceled = "canceled",
  expired = "expired",
  refunded = "refunded",
  pending = "pending",
}
